import React, { useContext, useEffect, useRef, useState } from "react";
import Input from "../../../elements/Input";
import Button from "../../../elements/Button";
import { LoginContext } from "../../../context/Login/LoginContext";
import { API_LINKS } from "../../../constant/Links";
import { ROUTES } from "../../../constant/Routes";
import { request } from "../../../utils/HttpRequest";
import Compressor from "compressorjs";
import { useNavigate } from "react-router-dom";
import { LoadingContext } from "../../../context/Loading/LoadingContext";
import { AiTwotoneEdit, AiFillCloseCircle } from "react-icons/ai";
import { getFixedNumber } from "../../../utils/Tools";

const editRequest = (formData, clear, lodingContext) => {
  lodingContext.startLoading();
  request(
    API_LINKS.BASE + API_LINKS.PACKET.UPDATE,
    formData,
    (res) => {
      editSuccess(res, clear, lodingContext);
    },
    (error) => {
      console.log(error);
      editFailed(lodingContext);
    }
  );
};

const editSuccess = (res, clear, lodingContext) => {
  lodingContext.endLoading();
  if (res.status) {
    clear();
    alert("تغییرات با موفقیت اعمال شد");
  } else {
    alert(res.msg);
  }
};

const editFailed = (lodingContext) => {
  lodingContext.endLoading();
  alert("اشکال در برقراری ارتباط با سرور");
};

const editInqiryRequest = (
  formData,
  initData,
  clear,
  lodingContext,
  setIsInquiry
) => {
  lodingContext.startLoading();
  request(
    API_LINKS.BASE + API_LINKS.PACKET.INQUIRY_FOR_EDIT,
    formData,
    (res) => {
      lodingContext.endLoading();
      if (res.status) {
        setIsInquiry(true);
        initData(res.info);
      } else {
        clear();
        alert("پاکت مورد نظر یافت نشد");
      }
    },
    (error) => {
      lodingContext.endLoading();
      clear();
      alert("اشکال در برقراری ارتباط با سرور");
    }
  );
};

const compresImage = (image, quality = 0.4, setFile) => {
  new Compressor(image, {
    quality: parseFloat(quality),
    success: (compressedResult) => {
      setFile(compressedResult);
    },
  });
};

const EditPakat = (props) => {
  const navigate = useNavigate();
  const loginContext = useContext(LoginContext);
  const lodingContext = useContext(LoadingContext);

  const packetNumRef = useRef(null);
  const ayarRef = useRef(null);
  const vaznRef = useRef(null);
  const vaznSampleRef = useRef(null);
  const mobileRef = useRef(null);

  const [validate, setValidate] = useState(0);

  const [file, setFile] = useState(null);

  const [img, setImg] = useState("");

  const [isInquiry, setIsInquiry] = useState(false);

  useEffect(() => {
    if (loginContext.userInfo == undefined) {
      navigate(ROUTES.LOGIN);
    }
  }, []);

  const handleImageChoose = (event) => {
    const files = event.target.files;
    if (files.length == 0) {
      return;
    }
    if (event.target.files && event.target.files[0]) {
      setImg(URL.createObjectURL(event.target.files[0]));
    }
    const image = files[0];
    compresImage(image, 0.6, setFile);
    setValidate(0);
  };

  const clearData = () => {
    packetNumRef.current.value = "";
    ayarRef.current.value = "";
    vaznRef.current.value = "";
    vaznSampleRef.current.value = "";
    mobileRef.current.value = "";
    setFile(null);
    setImg("");
  };

  const initData = (obj) => {
    packetNumRef.current.value = obj.number;
    console.log(packetNumRef.current.disable);
    ayarRef.current.value = getFixedNumber(parseFloat(obj.cutie), 3);
    vaznRef.current.value = getFixedNumber(parseFloat(obj.weight), 2);
    vaznSampleRef.current.value = getFixedNumber(
      parseFloat(obj.sampleWeight),
      3
    );
    mobileRef.current.value = obj.mobile;
    setImg(API_LINKS.BASE_PIC + obj.pic);
  };

  const submitHandle = () => {
    const packetNum = packetNumRef.current.value;
    const ayar = ayarRef.current.value;
    const vazn = vaznRef.current.value;
    const vaznSample = vaznSampleRef.current.value;
    const mobile = mobileRef.current.value;
    const userId = loginContext.userInfo.id;

    if (packetNum.length < 8) {
      setValidate(1);
      packetNumRef.current.focus();
      return;
    }

    if (isNaN(parseFloat(vazn)) || parseFloat(vazn) <= 0) {
      setValidate(2);
      vaznRef.current.focus();
      return;
    }

    if (ayar.length !== 3 || isNaN(parseFloat(ayar))) {
      setValidate(3);
      ayarRef.current.focus();
      return;
    }

    if (
      isNaN(parseInt(mobile)) ||
      mobile.length !== 11 ||
      mobile[0] + mobile[1] !== "09"
    ) {
      setValidate(4);
      mobileRef.current.focus();
      return;
    }

    if (file == null && img == "") {
      setValidate(5);
      return;
    }

    setValidate(0);

    const obj = {
      laboratoryId: userId,
      number: packetNum,
      cutie: ayar,
      weight: vazn,
      sampleWeight: vaznSample,
      mobile: mobile,
    };

    if (file != null) {
      obj.pic = file;
    }

    editRequest(obj, clearData, lodingContext);
  };

  const editHandle = () => {
    const packetNum = packetNumRef.current.value;
    const userId = loginContext.userInfo.id;

    if (packetNum.length < 8) {
      setValidate(1);
      packetNumRef.current.focus();
      return;
    }

    const formData = {
      number: packetNum,
      laboratoryId: userId,
    };

    editInqiryRequest(
      formData,
      initData,
      clearData,
      lodingContext,
      setIsInquiry
    );
  };

  const closeHandle = () => {
    setIsInquiry(false);
    clearData();
  };

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2">
        <div className="grid grid-cols-3">
          <div className="col-span-2">
            <Input
              extraClass="rounded-2xl"
              type="text"
              placeHolder="شماره پاکت"
              inputMode="numeric"
              padding="p-3"
              refrence={packetNumRef}
              mode={validate === 1 ? "error" : "normal"}
              message={validate === 1 ? "شماره پاکت باید 8 رقمی باشد" : ""}
              handler={() => {
                setValidate(0);
              }}
              disabled={isInquiry}
            />
          </div>
          <div className="text-center mt-10">
            {isInquiry ? (
              <Button
                extraClass=" text-darkTextPrimary "
                padding="py-3 px-3"
                icon={<AiFillCloseCircle className="text-xl" />}
                type="submit"
                variant="danger"
                content="انصراف"
                rounded="rounded-2xl"
                onClick={closeHandle}
              />
            ) : (
              <Button
                extraClass=" text-darkTextPrimary "
                padding="py-3 px-3"
                icon={<AiTwotoneEdit className="text-xl" />}
                type="submit"
                variant="success"
                content="ویرایش"
                rounded="rounded-2xl"
                onClick={editHandle}
              />
            )}
          </div>
        </div>
        <div>
          <Input
            extraClass="rounded-2xl"
            type="text"
            placeHolder="وزن کل"
            padding="p-3"
            refrence={vaznRef}
            inputMode="numeric"
            mode={validate === 2 ? "error" : "normal"}
            message={validate === 2 ? "وزن را به درستی وارد کنید" : ""}
            handler={() => {
              setValidate(0);
            }}
          />
        </div>
        <div>
          <Input
            extraClass="rounded-2xl"
            type="text"
            placeHolder="وزن نمونه"
            inputMode="numeric"
            padding="p-3"
            refrence={vaznSampleRef}
            handler={() => {
              setValidate(0);
            }}
          />
        </div>
        <div>
          <Input
            extraClass="rounded-2xl"
            type="text"
            placeHolder="عیار"
            inputMode="numeric"
            padding="p-3"
            refrence={ayarRef}
            mode={validate === 3 ? "error" : "normal"}
            message={validate === 3 ? "عیار را به درستی وارد کنید" : ""}
            handler={() => {
              setValidate(0);
            }}
          />
        </div>
        <div>
          <Input
            extraClass="rounded-2xl"
            type="text"
            placeHolder="موبایل درخواست کننده"
            padding="p-3"
            inputMode="numeric"
            refrence={mobileRef}
            maxLength="11"
            mode={validate === 4 ? "error" : "normal"}
            message={validate === 4 ? "موبایل را به درستی وارد کنید" : ""}
            handler={() => {
              setValidate(0);
            }}
          />
        </div>
        <div>
          <Input
            extraClass="rounded-2xl"
            type="file"
            placeHolder="عکس"
            padding="p-3"
            accept="image/*,capture=camera"
            mode={validate === 5 ? "error" : "normal"}
            message={validate === 5 ? "عکس الزامی است" : ""}
            handler={handleImageChoose}
          />
        </div>
        {img != "" ? (
          <div className=" flex items-center justify-center">
            <img className="rounded-lg" src={img} />
          </div>
        ) : null}
        <div className="text-center sm:col-span-2">
          <Button
            extraClass="text-darkTextPrimary my-4"
            padding="py-3 px-10"
            icon={<AiTwotoneEdit className="text-xl" />}
            type="submit"
            variant="success"
            content="ثبت تغییرات"
            rounded="rounded-2xl"
            onClick={submitHandle}
          />
        </div>
      </div>
    </>
  );
};

export default EditPakat;
